(function(){
 'use strict';
 function init(scope){
  scope.querySelectorAll('[data-mnr-products], [data-mnr-categories]').forEach(function(root){
   if(root.dataset.ready)return;
   var track=root.querySelector('.mnr-product-slider, [data-mnr-category-track]');
   if(!track)return;
   root.dataset.ready='true';
   var filters=root.querySelector('.mnr-filters'),controls=root.querySelector('.mnr-slider-controls');
   var prev=root.querySelector('[data-mnr-prev]'),next=root.querySelector('[data-mnr-next]');
   var cards=Array.from(track.querySelectorAll('.mnr-card, .mn-catalog__card, .mnr-category')),frame=0;
   function rtl(){return getComputedStyle(track).direction==='rtl';}
   function position(){return Math.abs(track.scrollLeft);}
   function maximum(){return Math.max(0,track.scrollWidth-track.clientWidth);}
   function update(){
    var max=maximum(),pos=position();
    controls.hidden=max<=1;
    prev.disabled=pos<=1;
    next.disabled=pos>=max-1;
   }
   function schedule(){if(!frame)frame=requestAnimationFrame(function(){frame=0;update();});}
   function go(pos,smooth){
    track.scrollTo({left:Math.max(0,Math.min(pos,maximum()))*(rtl()?-1:1),behavior:smooth&&!window.matchMedia('(prefers-reduced-motion: reduce)').matches?'smooth':'instant'});
    schedule();
   }
   function move(direction){
    var card=cards.find(function(item){return !item.hidden;});
    if(!card)return;
    var gap=parseFloat(getComputedStyle(track).columnGap)||0,step=card.getBoundingClientRect().width+gap;
    var count=Math.max(1,Math.floor((track.clientWidth+gap+1)/step));
    go(position()+direction*step*count,true);
   }
   function filter(button){
    var count=0;
    cards.forEach(function(card){
     card.hidden=button.dataset.filter!=='all'&&card.dataset.group!==button.dataset.filter;
     if(!card.hidden)count++;
    });
    filters.querySelectorAll('[data-filter]').forEach(function(item){item.setAttribute('aria-pressed',String(item===button));});
    root.querySelector('.mnr-no-results').hidden=count>0;
    go(0,false);
    update();
   }
   if(filters){
    filters.hidden=false;
    filters.addEventListener('click',function(event){var button=event.target.closest('[data-filter]');if(button&&filters.contains(button))filter(button);});
   }
   prev.addEventListener('click',function(){move(-1);});
   next.addEventListener('click',function(){move(1);});
   track.addEventListener('scroll',schedule,{passive:true});
   track.addEventListener('keydown',function(event){
    if(event.target!==track)return;
    if(event.key==='ArrowRight'||event.key==='ArrowLeft'){
     event.preventDefault();move((event.key==='ArrowRight'?1:-1)*(rtl()?-1:1));
    }else if(event.key==='Home'||event.key==='End'){
     event.preventDefault();go(event.key==='Home'?0:maximum(),true);
    }
   });
   function selectBlock(event){
    var card=event.target.closest('.mnr-card, .mn-catalog__card, .mnr-category');
    if(!card||!root.contains(card))return;
    if(card.hidden&&filters)filter(filters.querySelector('[data-filter="all"]'));
    card.scrollIntoView({block:'nearest',inline:'nearest',behavior:'instant'});
    schedule();
   }
   var observer;
   if(window.ResizeObserver){observer=new ResizeObserver(schedule);observer.observe(track);}
   else window.addEventListener('resize',schedule);
   function cleanup(event){
    if(event.target!==root&&!event.target.contains(root))return;
    if(observer)observer.disconnect();
    window.removeEventListener('resize',schedule);
    document.removeEventListener('shopify:block:select',selectBlock);
    document.removeEventListener('shopify:section:unload',cleanup);
    if(frame)cancelAnimationFrame(frame);
   }
   document.addEventListener('shopify:block:select',selectBlock);
   document.addEventListener('shopify:section:unload',cleanup);
   update();
  });
 }
 if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',function(){init(document);});else init(document);
 document.addEventListener('shopify:section:load',function(event){init(event.target);});
})();


(function(){
 'use strict';
 function init(scope){scope.querySelectorAll('[data-mnr-video]').forEach(function(root){
  if(root.dataset.videoReady)return;root.dataset.videoReady='true';
  var video=root.querySelector('video'),button=root.querySelector('.mnr-video-toggle');if(!video||!button)return;
  var motion=window.matchMedia('(prefers-reduced-motion: reduce)'),wantsPlay=!motion.matches,visible=false;
  video.muted=true;video.controls=false;button.hidden=false;
  function label(){var paused=video.paused;button.querySelector('.mnr-video-label').textContent=paused?button.dataset.play:button.dataset.pause;button.querySelector('[data-video-play]').hidden=!paused;button.querySelector('[data-video-pause]').hidden=paused;}
  function sync(){if(wantsPlay&&visible&&!document.hidden){var attempt=video.play();if(attempt)attempt.catch(label);}else video.pause();label();}
  video.addEventListener('play',label);video.addEventListener('pause',label);
  button.addEventListener('click',function(){wantsPlay=video.paused;sync();});
  function preference(){wantsPlay=!motion.matches;sync();}motion.addEventListener('change',preference);
  document.addEventListener('visibilitychange',sync);
  var observer;if(window.IntersectionObserver){observer=new IntersectionObserver(function(entries){visible=entries[0].isIntersecting;sync();},{threshold:.1});observer.observe(video);}else{visible=true;sync();}
  function cleanup(e){if(!e.target.contains(root))return;if(observer)observer.disconnect();video.pause();motion.removeEventListener('change',preference);document.removeEventListener('visibilitychange',sync);document.removeEventListener('shopify:section:unload',cleanup);}
  document.addEventListener('shopify:section:unload',cleanup);label();
 });}
 if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',function(){init(document)});else init(document);
 document.addEventListener('shopify:section:load',function(e){init(e.target)});
})();
(function(){function init(scope){scope.querySelectorAll('[data-mnr-support]').forEach(function(root){if(root.dataset.supportReady)return;root.dataset.supportReady='true';var box=root.querySelector('.mnr-support-search'),input=box.querySelector('input'),empty=root.querySelector('.mnr-support-empty');box.hidden=false;input.addEventListener('input',function(){var query=input.value.trim().toLocaleLowerCase(),count=0;root.querySelectorAll('.support-card').forEach(function(card){card.hidden=!card.dataset.supportTitle.toLocaleLowerCase().includes(query);if(!card.hidden)count++});empty.hidden=count!==0;});});}if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',function(){init(document)});else init(document);document.addEventListener('shopify:section:load',function(e){init(e.target)});})();
